export const GET_ACCOUNTS_QUERY = `
    query Accounts ($admin: Boolean) {
        accounts(admin: $admin) {
            id
            name
            image
            type
        }
    }
`;

export const GET_ACCOUNT_TEAM_MEMBERS_QUERY = `
    query TeamMembers($account_id: Int!) {
        teamMembers(account_id: $account_id) {
            invite_url
            workspaces {
                applies_to_all
                invited_date
                features {
                        invited_date
                        role {
                            id
                            name
                            seniority
                        }
                        invited_by {
                            id
                            first_name
                            last_name
                            username
                            email
                            phone
                            avatar
                        }
                    }
                workspace {
                    id
                    name
                    image
                    archived
                }
                role {
                    id
                    name
                    seniority
                }
                invited_by {
                    id
                    first_name
                    last_name
                    username
                    email
                    phone
                    avatar
                }
            }
            user {
                id
                first_name
                last_name
                username
                email
                phone
                avatar
                verified
                last_login
            }
            role {
                id
                name
                seniority
            }
        }
    }
`;

export const GET_ACCOUNT_PRODUCTS_QUERY = `
    query Products($account_id: Int!, $page: Int, $limit: Int) {
        products(account_id: $account_id, page: $page, limit: $limit) {
            id
            name
            image_url
            archived
        }
    }
`;

export const GET_WORKSPACE_PRODUCTS_QUERY = `
    query Products($account_id: Int!, $workspace_id: Int!, $page: Int = 1, $limit: Int = 40) {
        products(account_id: $account_id, workspace_id : $workspace_id, page: $page, limit: $limit) {
            id
            name
            image_url
            archived
        }
    }
`;

export const SEARCH_WORKSPACE_PRODUCTS_QUERY = `
    query SearchProducts($account_id: Int!, $workspace_id: Int!, $query: String $page: Int, $limit: Int) {
        searchProducts(account_id: $account_id, workspace_id: $workspace_id, query: $query, page: $page, limit: $limit) {
            id
            name
            image_url
            archived
            product_retailers {
                id
                sku
                url
                image_url
            }
        }
    }
`;
